import { ofType } from 'redux-observable';
import { from, Observable } from 'rxjs';
import {
    gamesReportSuccess,
    GamesReportTypes,
} from '../../actions/backoffice/games-report-actions';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
    currencyUtils,
    dateFormatter,
    getLoginRequestHeader,
    localStorageHelper,
} from '../../../utils';
import { of } from 'rxjs';
import { IAction, IStateObservable } from '../../../helpers/interfaces';
import { apiError } from '../../actions/user-actions';
import axios from 'axios';
import { SERVER_URL } from '../../../utils/config';

export const gamesReportEpic = (action$: Observable<IAction>, state$: IStateObservable) =>
    action$.pipe(
        ofType(GamesReportTypes.GAMES_REPORT_REQUEST),
        mergeMap((action) => {
            const requestBody = {
                roundTypes: action.payload.roundTypes,
                includeTestPlayers:
                    localStorageHelper.getChainedValue('user.preferences.displayTestData') ||
                    state$.value.userReducer.shouldDisplayTestData,
                playerCurrencyIds: currencyUtils.getSelectedCurrenciesIdsData(),
                start: dateFormatter.getFormattedStartDate(action.payload.fromDate),
                end: dateFormatter.getFormattedEndDate(action.payload.toDate),
                deviceType:
                    localStorageHelper.getChainedValue('user.reports.filters.deviceType') || 'all',
                currencyBreakdown: localStorageHelper.getChainedValue(
                    'user.reports.filters.currenciesBreakdown',
                )
                    ? 'currency'
                    : 'none',
            };

            return from(
                axios.post(
                    `${SERVER_URL}/reports/revenue/by-game-with-round-types`,
                    JSON.stringify(requestBody),
                    {
                        headers: getLoginRequestHeader('application/json'),
                    },
                ),
            ).pipe(
                map((response) => gamesReportSuccess(response.data)),
                catchError((error) => of(apiError(error, GamesReportTypes.GAMES_REPORT_REQUEST))),
            );
        }),
    );

export const OLDgamesReportEpic = (action$: Observable<IAction>, state$: IStateObservable) =>
    action$.pipe(
        ofType(GamesReportTypes.OLD_GAMES_REPORT_REQUEST),
        mergeMap((action) => {
            const requestBody = {
                roundTypes: action.payload.roundTypes,
                includeTestPlayers:
                    localStorageHelper.getChainedValue('user.preferences.displayTestData') ||
                    state$.value.userReducer.shouldDisplayTestData,
                playerCurrencyIds: currencyUtils.getSelectedCurrenciesIdsData(),
                start: dateFormatter.getFormattedStartDate(action.payload.fromDate),
                end: dateFormatter.getFormattedEndDate(action.payload.toDate),
                deviceType:
                    localStorageHelper.getChainedValue('user.reports.filters.deviceType') || 'all',
                currencyBreakdown: localStorageHelper.getChainedValue(
                    'user.reports.filters.currenciesBreakdown',
                )
                    ? 'currency'
                    : 'none',
            };

            return from(
                axios.post(`${SERVER_URL}/reports/revenue/by-game`, JSON.stringify(requestBody), {
                    headers: getLoginRequestHeader('application/json'),
                }),
            ).pipe(
                map((response) => gamesReportSuccess(response.data)),
                catchError((error) => of(apiError(error, GamesReportTypes.GAMES_REPORT_REQUEST))),
            );
        }),
    );
